(function () {
  /*
   * Uploaded videos ship with the browser control bar. Drop that bar and
   * keep each clip looping. Autoplay videos stay muted, which is what
   * lets them start on their own.
   */
  function quiet(video) {
    if (video.dataset.customVideoQuiet === 'true') return;
    video.dataset.customVideoQuiet = 'true';
    video.controls = false;
    video.loop = true;
    video.muted = true;
    video.setAttribute('playsinline', '');

    if (!video.autoplay && !video.closest('[autoplay]')) return;

    function start() {
      video.play().catch(function () {});
    }

    if (video.readyState >= 2) start();
    else video.addEventListener('canplay', start, { once: true });
  }

  function boot(root) {
    (root || document).querySelectorAll('video').forEach(quiet);
  }

  boot(document);

  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'VIDEO') quiet(node);
        else if (node.querySelectorAll) node.querySelectorAll('video').forEach(quiet);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
